const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const resolveSrc = (url) =>
  url && url.startsWith('http') ? url : `${BACKEND_URL}${url}`;

export const formatDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString('en-ZA', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  } catch (e) {
    return iso;
  }
};
